import type { BasicTrip } from 'tripPlanner/types/common'

export const DEFAULT_TRIP_NAME = 'New Trip'

export const getUniqueTripName = (
  original: string,
  trips: Array<BasicTrip>,
  maxLength: number,
  defaultName: string = DEFAULT_TRIP_NAME,
): string => {
  let num = 0
  const nonEmptyOriginal = original || defaultName
  let proposed = prepareProposedTripName(maxLength, undefined, nonEmptyOriginal, defaultName)

  const existingNames = new Set(trips.map((trip) => trip.name))
  while (existingNames.has(proposed)) {
    num++
    const suffix = ` (${num})`
    proposed = prepareProposedTripName(maxLength, suffix, nonEmptyOriginal, defaultName)
  }

  return proposed.replace(/[\n\r]/g, ' ')
}

export const prepareProposedTripName = (
  maxLength: number,
  suffix?: string,
  original?: string,
  defaultName: string = DEFAULT_TRIP_NAME,
) => {
  if (original) {
    const additionalLength = suffix?.length || 0
    const trimmed = original.substring(0, maxLength - additionalLength - 1)
    return trimmed + (suffix ?? '')
  } else {
    return defaultName
  }
}
